import { Box, styled } from '@mui/material';

const DateStack = styled(Box)`
  gap: 20px;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
`;

export default DateStack;
